import simpleModal from "./_simpleModal";

export default function headerVideo(el) {
  if (el.href === undefined) {
    return false;
  }

  const videoURL = new URL(el.href);
  const videoTitle = el.dataset.title;

  el.addEventListener("click", e => {
    e.preventDefault();

    const modalContent = `
      <div class="aspect-ratio-16/9 relative">
        <iframe class="absolute inset-0 w-full h-full" src="${videoURL}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <h1 class="p-4 bg-red text-white-off text-center">${videoTitle}</h1>
    `;

    simpleModal(modalContent);
  });
}
